import {flow, getEnv, getType, types} from "mobx-state-tree";
import lodash from "lodash";
import {create,DataDeliveryType} from "../../models/data/exports/DataDeliveryType";

const DataDeliveryTypeStore = types.model('DataDeliveryTypeStore',{
  storeUuid: types.identifier,
  dataDeliveryTypes: types.optional(types.array(DataDeliveryType), [])
}).actions((self) => ({
  setDataDeliveryTypes(data) {
    self.dataDeliveryTypes = data?.map(create)
    self.sortDataDeliveryTypes();
  },
  initWithData(data = [], enabledDeliveryTypes = ["email"]) {
    try {
      if (data) {
        data = lodash.filter(data, t => enabledDeliveryTypes.includes(t.type));
        self.setDataDeliveryTypes(data);
      }
    } catch (e) {
      console.error(`${getType(self).name} Error: Failed to initWithData`, e);
    }
  },
  init: flow(function* (queryParams = {}) {
    const response = yield getEnv(self).dataExportManger.fetchAllDeliveryTypes(queryParams, self)
    self.initWithData(response.results);
  }),
  sortDataDeliveryTypes() {
    try {
      self.dataDeliveryTypes?.sort((a, b) => a.label.localeCompare(b.label));
    } catch (e) {
      console.warn(`${getType(self).name} Warn: Failed to sort`, e);
    }
  },
})).views((self) => ({
  getDataDeliveryTypes() {
    return self.dataDeliveryTypes;
  }
}));

export default DataDeliveryTypeStore;
